import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { Row, Col, Card } from "react-bootstrap";
import Home from "../Home";
import { subscribeToOrder, subscribeToTableOrder } from "../../helpers/socket";
import { Badge } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getOnlineTableBookingCount, getOrderCount } from "../../action/ordersAction";
const Report = (props) => {
  const dispatch = useDispatch()
  const [onlineOrderCount, setonlineOrderCount] = useState("");
  const [onlineTableBookingCount, setonlineTableBookingCount] = useState();
  const onlineCount = useSelector((state) => state.orderCount.orders);
  const onlineTableCount = useSelector(
    (state) => state.onlineTableBookingCount.orders
  );

  useEffect(() => {
    subscribeToOrder(async (err, orders) => {
      dispatch(getOrderCount());
    });
    subscribeToTableOrder(async (err, orders) => {
      useDispatch(getOnlineTableBookingCount());
    });
  }, []);

  useEffect(() => {
    let count1 = localStorage.getItem("onlineOrderCount");
    setonlineOrderCount(count1);
  }, [onlineCount]);

  useEffect(() => {
    let count2 = localStorage.getItem("onlineTableCount");
    setonlineTableBookingCount(count2);
  }, [onlineTableCount]);

  const renderPage = () => {
    return (
      <Home>
        <div className="report-container text-center">
          <span className="item ">Rapporter</span>
        </div>
        <Card>
          <Card.Body>
            <Row className="m-b-1">
              <Col className=" text-center">
                <NavLink to="/rapporter/daily-report" className="btn btn-link" style={{width:"120px" , padding:"30px"}}>
                  DAILY REPORT
                </NavLink>
              </Col>
              <Col className=" text-center">
                <NavLink to="/rapporter/x-report" className="btn btn-link" style={{width:"120px" , padding:"30px"}}>
                  X REPORT
                </NavLink>
              </Col>
            </Row>
            <Row className="m-b-1">
              <Col className=" text-center">
                <NavLink to="/rapporter/cash-report" className="btn btn-link" style={{width:"120px" , padding:"30px"}}>
                  CASH REPORT
                </NavLink>
              </Col>
              <Col className=" text-center">
                <NavLink to="/rapporter/online-order" className="btn btn-link" style={{width:"120px" , padding:"30px"}}>
                  ONLINE ORDERS
                </NavLink>
                {onlineOrderCount && Number(onlineOrderCount) ? <Badge  style={{ position: "absolute",top:"-5px",right:"131px"}} bg="danger">{onlineOrderCount}</Badge> : ""}

              </Col>
            </Row>
            {JSON.parse(localStorage.getItem('branchInfo')).isQrAllow &&
            <Row className="m-b-1">
              <Col className=" text-center">
                <NavLink to="/rapporter/dailydining" className="btn btn-link" style={{width:"120px" , padding:"30px"}}>
                 DIGITAL DINE IN
                </NavLink>
                {onlineTableBookingCount && Number(onlineTableBookingCount) ? <Badge   bg="danger">{onlineTableBookingCount}</Badge> : ""}
              </Col>
              
            </Row>}
      
    
            
          </Card.Body>
        </Card>
      </Home>
    );
  };
  return <>{renderPage()}</>;
};

export default Report;
